<template>
  <div class="repairPolicy-container">
    <div>
      <div class="repairPolicy-main" v-html="desc"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      desc: "",
    };
  },
  methods: {
    async getRepairPolicy() {
      let res = await this.$http.getRepairPolicy();
      this.desc = res.data.description;
      this.$nextTick(() => {
        let arr = document.getElementsByTagName("img");
        for (let img of arr) {
          img.style.maxWidth = `${img.width}px`;
          img.style.height = `auto`;
          img.style.width = `100%`;
        }
      });
    },
  },
  created() {
    this.getRepairPolicy();
  },
};
</script>

<style lang="scss">
.repairPolicy-container {
  flex: 1;
  display: flex;
  padding: 15px;
  overflow-y: auto;
  .repairPolicy-main {
    display: inline-block;
    word-wrap: break-word;
    overflow: hidden;
    word-break: break-word;
  }
}
</style>
